
import Forward from "../../../assets/outline/Forward.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ForwardIcon({ className, dataTestid = "ForwardIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Forward data-testid={dataTestid} className={classes} {...rest} />
  );
}
